<template>
  <div class="sip-file-upload">
    <file-dropzone
        v-if="!disableUpload"
        ref="dropzone"
        :button-text="buttonText"
        :accept="acceptAttr"
        :disabled="isUploadDisabled"
        @selected="onFileSelected"
    />

    <file-upload-progress :progress="progress" class="sip-file-upload__progress"></file-upload-progress>
    <button type="button" class="btn btn-sm sip-file-upload__cancel" @click="cancelUpload" v-if="progress || isFileSelected">
        <em class="icon ni ni-cross"></em> {{ trans('general.cancel_upload') }}
    </button>

    <ul class="sip-file-upload__list" v-if="uploaded_files && uploaded_files.length">
        <li class="sip-file-upload__item" v-for="uploaded_file in uploaded_files" :key="uploaded_file.id">
            <span v-if="!disableDelete" class="sip-file-upload__remove" v-confirm="{ok: confirmDelete(uploaded_file)}">
                <i class="fas fa-times pointer text-danger"></i>
            </span>
            <i :class="['file-icon', 'fas', uploaded_file.file_info.icon]"></i>
            <span class="sip-file-upload__name">{{uploaded_file.user_filename}}</span>
            <span class="sip-file-upload__size">{{uploaded_file.file_info.size}}</span>
        </li>
    </ul>
  </div>
</template>

<script>
    import fileUploadProgress from './file-upload-progress.vue'
    import fileDropzone from './file-dropzone.vue'

    export default {
        components : { fileUploadProgress, fileDropzone },
        props: {
            buttonText: {
                default: 'Choose File',
            },
            token: {
                required: true
            },
            module: {
                required: true
            },
            moduleId: {
                default: ''
            },
            clearFile: {
                default: false
            },
            disableDelete: {
                default: false
            },
            disableUpload: {
                default: false
            }
        },
        watch: {
            file(file){
                if (!file || !file.name) {
                    return;
                }
                let fileExtension = file.name.substr((file.name.lastIndexOf('.') + 1));

                if(this.allowed_file_extensions.indexOf(fileExtension) == -1){
                    NioApp.Toast(i18n.general.file_not_allowed, 'error');
                    this.isUploadDisabled = false;
                    this.resetDropzone();
                } else if(file.size > helper.getConfig('post_max_size')){
                    NioApp.Toast(i18n.general.file_too_large, 'error');
                    this.isUploadDisabled = false;
                    this.resetDropzone();
                } else {
                    this.isUploadDisabled = true;
                    let formData = new FormData();
                    formData.append('file', file);
                    formData.append('token', this.token);
                    formData.append('module', this.module);
                    formData.append('module_id', this.moduleId || '');
                    axios.post('/api/guest-upload',formData, {
                        onUploadProgress: progressEvent => {
                            this.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        }
                    }).then(response => {
                        NioApp.Toast(response.message, 'success');
                        this.uploaded_files.push(response.upload);
                        this.$emit('uploaded', response.upload)
                    }).catch(error => {
                        if(error.response.status == 413)
                        NioApp.Toast(i18n.general.file_too_large, 'error');
                        else
                            helper.showErrorMsg(error);
                    }).then(() => {
                        this.progress = 0;
                        this.isUploadDisabled = false;
                        this.resetDropzone();
                    });
                }
            },
            clearFile(val){
                this.uploaded_files = [];
            },
            moduleId(val){
                if(val)
                    this.fetchUploads();
            }
        },
        mounted(){
            if(this.moduleId)
                this.fetchUploads();

            axios.post('/api/guest-upload/extension',{module: this.module})
                .then(response => {
                    this.allowed_file_extensions = response;
                })
                .catch(error => {

                });
        },
        computed: {
            authToken(){
                return helper.getAuthToken();
            },
            isFileSelected(){
                return this.isUploadDisabled ? true : false;
            },
            acceptAttr(){
                if (!this.allowed_file_extensions || !this.allowed_file_extensions.length) {
                    return '';
                }
                return this.allowed_file_extensions.map(ext => {
                    const clean = String(ext || '').replace(/^\./, '');
                    return clean ? '.' + clean : '';
                }).filter(Boolean).join(',');
            }
        },
        methods: {
            onFileSelected(file) {
                this.file = file;
            },
            resetDropzone(){
                if (this.$refs.dropzone && this.$refs.dropzone.clear) {
                    this.$refs.dropzone.clear();
                }
            },
            cancelUpload(){
                if (this.request) {
                    this.request.abort();
                }
                this.isUploadDisabled = false;
                this.progress = 0;
                this.resetDropzone();
            },
            confirmDelete(uploaded_file){
                return dialog => this.deleteUpload(uploaded_file);
            },
            deleteUpload(uploaded_file){
                let loader = this.$loading.show();
                axios.post('/api/guest-upload/'+uploaded_file.id,{
                    token: uploaded_file.upload_token,
                    module_id: this.moduleId || ''
                }).then(response => {
                    this.uploaded_files = this.uploaded_files.filter(function (item) {
                        return uploaded_file.id != item.id;
                    });
                    NioApp.Toast(response.message, 'success');
                    this.$emit('removed', uploaded_file)
                    loader.hide();
                }).catch(error => {
                    loader.hide();
                    helper.showErrorMsg(error);
                });
            },
            fetchUploads(){
                this.uploaded_files = [];
                axios.post('/api/guest-upload/fetch',{
                    module: this.module,
                    module_id: this.moduleId
                })
                .then(response => {
                    this.uploaded_files = response;
                })
                .catch(error => {
                    helper.showErrorMsg(error);
                });
            }
        },
        data() {
            return {
              file: '',
              isUploadDisabled: false,
              progress: 0,
              uploaded_files: [],
              allowed_file_extensions: []
            }
        }
    }
</script>
